import React from 'react';
import Select from 'react-select';
import NPReactTable from "../../../NPReactTable";
import { Row, Col, Button } from 'react-bootstrap';
import NPPanel from '../../../NPPanel';
import axios from 'axios';
import constants from '../../../util/constants';
import Dialog from 'react-bootstrap-dialog';
import FontAwesome from 'react-fontawesome';
import { removeRow } from '../../../gridHelpers/gridHelpers';
import { showSaveDialog } from '../../../Allocation/AllocationHelper';
import LoadingSpinner from '../../../LoadingSpinner';

const { API_BASE_URL } = constants;

const numberCell = row => row.value?.toLocaleString('sv', { useGrouping: true }) || '0';

class ExternalCapacity extends React.Component{
  constructor(props) {
    super(props);
    const currentYear = new Date().getFullYear();
    this.state={
      header: this.props.apiToken ? {
          'Authorization': 'Bearer ' +  this.props.apiToken,
          'Accept': 'application/octet-stream'
      } : {},
      isLoading: false,
      availableYears: [],
      capacityData: [],
      removedCapacityData: [],
      removedRow: -1,
      selectedYear: {value: currentYear, label: currentYear },
      expandedConverters: {},
      expandedMonths: {}
    };
  }

  handleConverterFieldChange(capacityIdx, field, value) {
    const capacityData = this.state.capacityData.map((cap, ci) =>
      ci !== capacityIdx ? cap : { ...cap, [field]: value }
    );
    this.setState({ capacityData });
  }

  handleMonthFieldChange(capacityIdx, monthIdx, value) {
    const capacityData = this.state.capacityData.map((cap, ci) => {
      if (ci !== capacityIdx) return cap;
      const months = cap.Months.map((month, mi) => {
        if (mi !== monthIdx) return month;
        const numWeeks = month.Weeks ? month.Weeks.length : 0;
        const weekCapacity = numWeeks > 0 ? value / numWeeks : 0;
        const weeks = month.Weeks.map(week => ({ ...week, Capacity: weekCapacity }));
        return { ...month, Capacity: value, Weeks: weeks };
      });
      return { ...cap, Months: months };
    });
    this.setState({ capacityData });
  }

  handleWeekFieldChange(capacityIdx, monthIdx, weekIdx, field, value) {
    const capacityData = this.state.capacityData.map((cap, ci) => {
      if (ci !== capacityIdx) return cap;
      const months = cap.Months.map((month, mi) => {
        if (mi !== monthIdx) return month;
        const weeks = month.Weeks.map((week, wi) =>
          wi !== weekIdx ? week : { ...week, [field]: value }
        );
        const monthCapacity = weeks.reduce((sum, week) => sum + (week.Capacity || 0), 0);
        return { ...month, Capacity: monthCapacity, Weeks: weeks };
      });
      return { ...cap, Months: months };
    });
    this.setState({ capacityData });
  }

  addYear() {
    this.setState(prev => {
      const years = prev.availableYears;
      const newYear = prev.availableYears.sort()[prev.availableYears.length - 1].value + 1;
      return {
        availableYears: [...prev.availableYears, { value: newYear, label: newYear }],
        selectedYear: { value: newYear, label: newYear },
        capacityData: []
      }
    });
  }

  save() {
    this.setState({ isLoading: true });
    let externalCapacityWrapper = {};
    externalCapacityWrapper.Capacity = this.state.capacityData;
    externalCapacityWrapper.RemovedCapacity = this.state.removedCapacityData;

    axios.post(API_BASE_URL + 'Allocation/SaveExternalCapacity', externalCapacityWrapper, { headers: this.state.header })
      .then(response => {
        this.setState({ isLoading: false });
        this.getData(this.state.selectedYear.value);
        window.location.reload();
      })
      .catch(error => {
        this.setState({ isLoading: false });
      });
  }

  getData(year) {
    const queryYear = '?year=' + year;
    this.setState({ isLoading: true });
    axios.get(API_BASE_URL + 'Allocation/GetExternalCapacity' + queryYear, { headers: this.state.header })
      .then(response => {
        let years = response.data.AvailableYears;
        const currentYear = new Date().getFullYear();
        if (years && !years.includes(currentYear)){
          years = [...years, currentYear];
        }
        this.setState({ 
          availableYears: years.map(y => ({ value: y, label: y })),
          capacityData: response.data.Capacity || [],
          isLoading: false
        });
      })
      .catch(error => {
        this.setState({ availableYears: [], capacityData: [], isLoading: false });
      });
  }

  componentDidMount() {
    const year = this.state.selectedYear.value;
    this.getData(year);
  }

  addNewRow() {
    //TODO: fetch from backend (as only backend knows how weeks are for the year)
    const queryYear = '?year=' + this.state.selectedYear.value;
    axios.get(API_BASE_URL + 'Allocation/GetNewExternalConverter' + queryYear, { headers: this.state.header })
      .then(response => {
        const newCapacity = response.data;
        this.setState(prevState => ({
          capacityData: [...prevState.capacityData, newCapacity]
        }));
      })
  }

  addRemovedRow() {
    if(this.state.removedRow === -1)
        return;
    this.state.removedCapacityData.push(this.state.removedRow);
    this.state.removedRow = -1;
  }

  getConverterColumns() {
    return [
      {
        Header: props =><FontAwesome className="handy" name="plus" onClick={() => { this.addNewRow()}} />, 
        maxWidth: 40,
        textAlign: "center",
        Cell: (props, row) =>
        <span style={{textAlign: "center"}}>                
          <FontAwesome
            className="handy"
            style={{textAlign: "center"}}
            name="minus"
            onClick={() => {
              this.state.removedRow = props.row._original;
              removeRow(this.state.capacityData, props.row._original, this, this.addRemovedRow.bind(this),'Remove converter machine capacity','Do you really want to remove this converter machine capacity?');
            }}
          />
        </span>               
      },
      {
        Header: 'Converter',
        accessor: 'CustomerId',
        maxWidth: 80,
        Cell: row => (
          <input
            type="text"
            className="form-control input-sm"
            value={row.value || ''}
            onChange={e => this.handleConverterFieldChange(row.index, 'CustomerId', e.target.value)}
            style={{ width: '70px' }}
          />
        ),
      },
      { expander: true, width: 35 },
      {
        Header: 'PM',
        accessor: 'Pm',
        maxWidth: 50,
        Cell: row => (
          <input
            type="text"
            className="form-control input-sm"
            value={row.value || ''}
            onChange={e => this.handleConverterFieldChange(row.index, 'Pm', e.target.value)}
            style={{ width: '40px' }}
          />
        ),
      },
      {
        Header: 'Description',
        accessor: 'Description',
        Cell: row => (
          <input
            type="text"
            className="form-control input-sm"
            value={row.value || ''}
            onChange={e => this.handleConverterFieldChange(row.index, 'Description', e.target.value)}
            style={{ width: '900px' }}
          />
        ),
      },
    ];
  }

  getMonthColumns(capacityIdx) {
    return [
        {
          Header: 'Month',
          accessor: 'Month',
          maxWidth: 60
        },
        {
          expander: true,
          width: 35
        },
        {
          Header: 'Capacity',
          accessor: 'Capacity',
          maxWidth: 100,
          Cell: row => {
            if (row.original.Month === 'Total') {
              return <span>{row.value || 0}</span>;
            }
            return (
              <input
                type="text"
                className="form-control input-sm"
                value={row.value || ''}
                onChange={e => this.handleMonthFieldChange(capacityIdx, row.index, parseFloat(e.target.value) || 0)}
                style={{ width: '900px' }}
              />
            )
          }
        },
    ];
  }

  getWeekColumns(capacityIdx, monthIdx, monthIsTotal) {
    return [
      { Header: 'Week', accessor: 'Week', maxWidth: 84 },
      {
        Header: 'Capacity',
        accessor: 'Capacity',
        maxWidth: 120,
        Cell: row => {
          if (monthIsTotal){
            return <span>{row.value || 0}</span>;
          }
          return(
            <input
              type="number"
              className="form-control input-sm"
              value={row.value}
              style={{ width: '80px' }}
              onChange={e => this.handleWeekFieldChange(capacityIdx, monthIdx, row.index, 'Capacity', parseFloat(e.target.value) || 0)}
            />
          )
          }
      },
    ];
  }

  render(){
    const { capacityData, isLoading } = this.state;
    if (isLoading) {
      return (
        <LoadingSpinner isLoading={true} />
      )
    }
    return (
      <div>
        <Dialog ref={(el) => { this.dialog = el }} />
        <NPPanel>
          <Row>
            <Col xs={12}>
              <div>  
                <legend className="mylegend capacityLegend">External Converter Capacity</legend>
                <Row>
                  <Col xs={12} className="addYear">  
                    <Select
                      isSearchable={true}
                      styles={{
                          valueContainer: (provided) => ({
                              ...provided,
                              minWidth: '50px'
                          }),
                      }}
                      isClearable={false}
                      options={this.state.availableYears}
                      menuContainerStyle={{ zIndex: 5 }}
                      value={this.state.selectedYear}
                      onChange={evt => {
                        this.setState({ selectedYear: evt }, () => this.getData(evt.value));
                      }}
                    />
                  <Button bsStyle="primary" className="btn-sm margin-left-5" onClick={evt => { this.addYear(); }}>
                    Add Year
                  </Button>
                  </Col>
                </Row>
              </div>
              <NPReactTable
                data={capacityData}
                columns={this.getConverterColumns()}
                showPagination={false}
                showPageSizeOptions={false}
                hasHeaderGroups={false}
                sortable={false}
                minRows={1}
                defaultPageSize={10000}
                className="margin-top-5 np-react-table allocationTable"
                expanded={this.state.expandedConverters}
                onExpandedChange={expanded => this.setState({ expandedConverters: expanded })}
                SubComponent={converterRow => (
                  <div style={{ padding: '10px' }}>
                    <NPReactTable
                      data={converterRow.original.Months || []}
                      columns={this.getMonthColumns(converterRow.index)}
                      showPagination={false}
                      defaultPageSize={10000}
                      minRows={1}
                      hasHeaderGroups={false}
                      sortable={false}
                      className="np-react-table allocationTable"
                      expanded={this.state.expandedMonths}
                      onExpandedChange={expanded => this.setState({ expandedMonths: expanded })}
                      SubComponent={monthRow => (
                        <div style={{ padding: '10px' }}>
                          <NPReactTable
                            data={monthRow.original.Weeks || []}
                            columns={this.getWeekColumns(converterRow.index, monthRow.index, monthRow.original.Month === 'Total')}
                            showPagination={false}
                            defaultPageSize={10000}
                            minRows={1}
                            hasHeaderGroups={false}
                            className="np-react-table allocationTable"
                          />
                        </div>
                      )}
                      />
                  </div>
                )}
              />
            </Col>
          </Row>
          <Row className="margin-top-10">
            <Col xs={12}>
              <Button bsStyle="primary" onClick={() => this.save()}>
                Save
              </Button>
            </Col>
          </Row>
        </NPPanel>
      </div>
    );
  }
}
export default ExternalCapacity;